export class Announcements {
    heading: string;
    date: string;
    description: string;
    colour: string;
    emailCheck: boolean;
    tags: any;
    labels: any;
    id: number;
}